import { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import withStyles from 'beam/dist/styles'

const phraseHitColor = 'yellow'
const userSearchColor = 'pink'
const userSearchSelectedColor = 'salmon'

const styles = theme => ({
  content: {
    ...theme.typography.body2,
    '&:focus': {
      outline: 'none',
    },
  },
  phraseHit: {
    background: phraseHitColor,
    color: 'black',
    '&:hover': {
      background: 'orange',
    },
  },
  userSearch: {
    background: userSearchColor,
  },
  userSearchSelected: {
    background: userSearchSelectedColor,
  },
  light: {
    color: theme.palette.common.white,
  },
})

const TranscriptionText = ({ clumps, setTime, classes, queryCurrentIndex, variant }) => {
  const isLight = variant === 'light'

  // This is removed for now, need to find a way to get this to work
  // const setFocusedText = el => {
  //   const focusedElement = document.activeElement
  //   if (el) {
  //     el.focus()
  //   }
  //   focusedElement.focus()
  // }

  const getClickHandler = clump => e => clump.hit && !e.stopPropagation() && setTime(clump.start)

  return (
    <Fragment>
      {clumps.map((clump, idx) => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- TODO: remove this eslint-disable or replace this eslint-disable comment with a proper justification
        <span
          key={idx}
          onClick={getClickHandler(clump)}
          tabIndex={-1}
          // ref={e => (clump.qHit && clump.qIndex === queryCurrentIndex ? setFocusedText(e) : null)}
          className={classNames(
            isLight && !clump.hit && classes.light,
            classes.content,
            clump.hit && classes.phraseHit,
            clump.qHit && classes.userSearch,
            clump.qHit && clump.qIndex === queryCurrentIndex ? classes.userSearchSelected : null,
          )}
        >
          {clump.words}
        </span>
      ))}
    </Fragment>
  )
}

TranscriptionText.propTypes = {
  clumps: PropTypes.array.isRequired,
  queryCurrentIndex: PropTypes.number.isRequired,
  setTime: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(['dark', 'light']),
}

TranscriptionText.defaultProps = {
  variant: 'dark',
}

export { TranscriptionText as UnstyledTranscriptionText }
export default withStyles(styles)(TranscriptionText)
